export const isAutenticated = (state) => state.auth.isAutenticated || false;
